import { defineStore } from 'pinia';

// Monotonically increasing id used to discard stale fetch responses when the
// user rapidly navigates between orders. Held outside the store state so that
// $reset() (used by the route-update hook) cannot rewind it and cause an older
// in-flight request to pass the staleness check.
let paymentsRequestCounter = 0;

export const usePaymentsStore = defineStore('payments', {
    state: () => {
        return {
            payments: [],
        };
    },
    actions: {
        // Payments
        async fetchPayments(orderId) {
            const requestId = ++paymentsRequestCounter;
            const {
                data: { data: response },
            } = await window.axios.get(`/orders/${orderId}/payments`);
            if (requestId !== paymentsRequestCounter) {
                return;
            }
            this.payments = response;
        },
        async patchPayment(orderId, paymentId, values) {
            const response = await window.axios.patch(`/orders/${orderId}/payments/${paymentId}`, {
                ...values,
            });
            let index = this.payments.findIndex((item) => item.id == paymentId);
            this.payments[index] = response.data.order_payment;
        },
        async deletePayment(orderId, paymentId) {
            await window.axios.delete(`/orders/${orderId}/payments/${paymentId}`);
            // Removal of payment is handled by the emitters in OrderPayments
        },

        // Refunds
        async fetchRefunds(orderId) {
            const {
                data: { data: response },
            } = await window.axios.get(`/orders/${orderId}/refunds`);
            this.refunds = response;
            console.log('Refunds data', response);
        },
        async patchRefund(orderId, refundId, values) {
            const response = await window.axios.patch(`/orders/${orderId}/payments/${refundId}`, {
                ...values,
            });
            let index = this.refunds.findIndex((item) => item.id == refundId);
            this.refunds[index] = response.data.order_refund;
        },
        async patchExternalRefund(orderId, refundId, values) {
            const response = await window.axios.patch(`/orders/${orderId}/refunds/external/${refundId}`, {
                stripe_id: values.pi_id,
                amount: values.amount,
                notes: values.notes,
            });
            let index = this.refunds.findIndex((item) => item.id == refundId);
            this.refunds[index] = response.data.order_refund;
        },
        async deleteRefund(orderId, refundId) {
            await window.axios.delete(`/orders/${orderId}/refunds/${refundId}`);
            // Removal of refund is handled by the emitters in Orderrefunds
        },
        async addRefund(orderId, values) {
            const response = await window.axios.post(`/orders/${orderId}/refunds/external`, {
                ...values,
            });
            this.refunds.push(response.data.order_refund);
        },
    },
    getters: {
        getPayments: (state) => {
            return state.payments;
        },
        getRefunds: (state) => {
            return state.refunds;
        },
    },
});
